var _regeneratorRuntime = require("/home/runner/actions-runner/_work/haribo/haribo/node_modules/@babel/runtime/regenerator");

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

var components = {
  'C006': function () {
    var _C = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return import('/home/runner/actions-runner/_work/haribo/haribo/frontend/src/components/01-components/006-MediaSlider/MediaSlider.client.ts');

            case 2:
              _context.t0 = _context.sent.default;
              return _context.abrupt("return", {
                type: 'vanilla',
                Component: _context.t0
              });

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    function C006() {
      return _C.apply(this, arguments);
    }

    return C006;
  }(),
  'C007': function () {
    var _C2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return import('/home/runner/actions-runner/_work/haribo/haribo/frontend/src/components/01-components/007-ContentSlider/ContentSlider.client.ts');

            case 2:
              _context2.t0 = _context2.sent.default;
              return _context2.abrupt("return", {
                type: 'vanilla',
                Component: _context2.t0
              });

            case 4:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    function C007() {
      return _C2.apply(this, arguments);
    }

    return C007;
  }(),
  'C008': function () {
    var _C3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return import('/home/runner/actions-runner/_work/haribo/haribo/frontend/src/components/01-components/008-VideoComponent/VideoComponent.client.ts');

            case 2:
              _context3.t0 = _context3.sent.default;
              return _context3.abrupt("return", {
                type: 'vanilla',
                Component: _context3.t0
              });

            case 4:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    function C008() {
      return _C3.apply(this, arguments);
    }

    return C008;
  }(),
  'C009': function () {
    var _C4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return import('/home/runner/actions-runner/_work/haribo/haribo/frontend/src/components/01-components/009-PlacesGeoSortList/PlacesGeoSortList.client.ts');

            case 2:
              _context4.t0 = _context4.sent.default;
              return _context4.abrupt("return", {
                type: 'vanilla',
                Component: _context4.t0
              });

            case 4:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));

    function C009() {
      return _C4.apply(this, arguments);
    }

    return C009;
  }(),
  'C010': function () {
    var _C5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return import('/home/runner/actions-runner/_work/haribo/haribo/frontend/src/components/01-components/010-ContentBoxFrame/ContentBoxFrame.client.ts');

            case 2:
              _context5.t0 = _context5.sent.default;
              return _context5.abrupt("return", {
                type: 'vanilla',
                Component: _context5.t0
              });

            case 4:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }));

    function C010() {
      return _C5.apply(this, arguments);
    }

    return C010;
  }(),
  'C011': function () {
    var _C6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
      return _regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return import('/home/runner/actions-runner/_work/haribo/haribo/frontend/src/components/01-components/011-ShowMoreList/ShowMoreList.client.ts');

            case 2:
              _context6.t0 = _context6.sent.default;
              return _context6.abrupt("return", {
                type: 'vanilla',
                Component: _context6.t0
              });

            case 4:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6);
    }));

    function C011() {
      return _C6.apply(this, arguments);
    }

    return C011;
  }(),
  'C013': function () {
    var _C7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
      return _regeneratorRuntime.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              _context7.next = 2;
              return import('/home/runner/actions-runner/_work/haribo/haribo/frontend/src/components/01-components/013-Modal/Modal.client.ts');

            case 2:
              _context7.t0 = _context7.sent.default;
              return _context7.abrupt("return", {
                type: 'vanilla',
                Component: _context7.t0
              });

            case 4:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7);
    }));

    function C013() {
      return _C7.apply(this, arguments);
    }

    return C013;
  }(),
  'C015': function () {
    var _C8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
      return _regeneratorRuntime.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              _context8.next = 2;
              return import('/home/runner/actions-runner/_work/haribo/haribo/frontend/src/components/01-components/015-TooltipHint/TooltipHint.vue');

            case 2:
              _context8.t0 = _context8.sent.default;
              return _context8.abrupt("return", {
                type: true,
                Component: _context8.t0
              });

            case 4:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8);
    }));

    function C015() {
      return _C8.apply(this, arguments);
    }

    return C015;
  }(),
  'C028': function () {
    var _C9 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9() {
      return _regeneratorRuntime.wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              _context9.next = 2;
              return import('/home/runner/actions-runner/_work/haribo/haribo/frontend/src/components/01-components/028-VideoModal/VideoModal.client.ts');

            case 2:
              _context9.t0 = _context9.sent.default;
              return _context9.abrupt("return", {
                type: 'vanilla',
                Component: _context9.t0
              });

            case 4:
            case "end":
              return _context9.stop();
          }
        }
      }, _callee9);
    }));

    function C028() {
      return _C9.apply(this, arguments);
    }

    return C028;
  }(),
  'C029': function () {
    var _C10 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10() {
      return _regeneratorRuntime.wrap(function _callee10$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              _context10.next = 2;
              return import('/home/runner/actions-runner/_work/haribo/haribo/frontend/src/components/01-components/029-DragScroller/DragScroller.client.ts');

            case 2:
              _context10.t0 = _context10.sent.default;
              return _context10.abrupt("return", {
                type: 'vanilla',
                Component: _context10.t0
              });

            case 4:
            case "end":
              return _context10.stop();
          }
        }
      }, _callee10);
    }));

    function C029() {
      return _C10.apply(this, arguments);
    }

    return C029;
  }(),
  'C045': function () {
    var _C11 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11() {
      return _regeneratorRuntime.wrap(function _callee11$(_context11) {
        while (1) {
          switch (_context11.prev = _context11.next) {
            case 0:
              _context11.next = 2;
              return import('/home/runner/actions-runner/_work/haribo/haribo/frontend/src/components/01-components/045-FilterGroup/FilterGroup.vue');

            case 2:
              _context11.t0 = _context11.sent.default;
              return _context11.abrupt("return", {
                type: true,
                Component: _context11.t0
              });

            case 4:
            case "end":
              return _context11.stop();
          }
        }
      }, _callee11);
    }));

    function C045() {
      return _C11.apply(this, arguments);
    }

    return C045;
  }(),
  'C046': function () {
    var _C12 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12() {
      return _regeneratorRuntime.wrap(function _callee12$(_context12) {
        while (1) {
          switch (_context12.prev = _context12.next) {
            case 0:
              _context12.next = 2;
              return import('/home/runner/actions-runner/_work/haribo/haribo/frontend/src/components/01-components/046-FilterCluster/FilterCluster.vue');

            case 2:
              _context12.t0 = _context12.sent.default;
              return _context12.abrupt("return", {
                type: true,
                Component: _context12.t0
              });

            case 4:
            case "end":
              return _context12.stop();
          }
        }
      }, _callee12);
    }));

    function C046() {
      return _C12.apply(this, arguments);
    }

    return C046;
  }(),
  'C047': function () {
    var _C13 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13() {
      return _regeneratorRuntime.wrap(function _callee13$(_context13) {
        while (1) {
          switch (_context13.prev = _context13.next) {
            case 0:
              _context13.next = 2;
              return import('/home/runner/actions-runner/_work/haribo/haribo/frontend/src/components/01-components/047-FilterPanel/FilterPanel.vue');

            case 2:
              _context13.t0 = _context13.sent.default;
              return _context13.abrupt("return", {
                type: true,
                Component: _context13.t0
              });

            case 4:
            case "end":
              return _context13.stop();
          }
        }
      }, _callee13);
    }));

    function C047() {
      return _C13.apply(this, arguments);
    }

    return C047;
  }(),
  'C048': function () {
    var _C14 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee14() {
      return _regeneratorRuntime.wrap(function _callee14$(_context14) {
        while (1) {
          switch (_context14.prev = _context14.next) {
            case 0:
              _context14.next = 2;
              return import('/home/runner/actions-runner/_work/haribo/haribo/frontend/src/components/01-components/048-Map/Map.vue');

            case 2:
              _context14.t0 = _context14.sent.default;
              return _context14.abrupt("return", {
                type: true,
                Component: _context14.t0
              });

            case 4:
            case "end":
              return _context14.stop();
          }
        }
      }, _callee14);
    }));

    function C048() {
      return _C14.apply(this, arguments);
    }

    return C048;
  }(),
  'C049': function () {
    var _C15 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee15() {
      return _regeneratorRuntime.wrap(function _callee15$(_context15) {
        while (1) {
          switch (_context15.prev = _context15.next) {
            case 0:
              _context15.next = 2;
              return import('/home/runner/actions-runner/_work/haribo/haribo/frontend/src/components/01-components/049-ImageZoom/ImageZoom.vue');

            case 2:
              _context15.t0 = _context15.sent.default;
              return _context15.abrupt("return", {
                type: true,
                Component: _context15.t0
              });

            case 4:
            case "end":
              return _context15.stop();
          }
        }
      }, _callee15);
    }));

    function C049() {
      return _C15.apply(this, arguments);
    }

    return C049;
  }(),
  'C052': function () {
    var _C16 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee16() {
      return _regeneratorRuntime.wrap(function _callee16$(_context16) {
        while (1) {
          switch (_context16.prev = _context16.next) {
            case 0:
              _context16.next = 2;
              return import('/home/runner/actions-runner/_work/haribo/haribo/frontend/src/components/01-components/052-RaffleForm/RaffleForm.vue');

            case 2:
              _context16.t0 = _context16.sent.default;
              return _context16.abrupt("return", {
                type: true,
                Component: _context16.t0
              });

            case 4:
            case "end":
              return _context16.stop();
          }
        }
      }, _callee16);
    }));

    function C052() {
      return _C16.apply(this, arguments);
    }

    return C052;
  }(),
  'M001': function () {
    var _M = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee17() {
      return _regeneratorRuntime.wrap(function _callee17$(_context17) {
        while (1) {
          switch (_context17.prev = _context17.next) {
            case 0:
              _context17.next = 2;
              return import('/home/runner/actions-runner/_work/haribo/haribo/frontend/src/components/02-modules/001-Header/Header.client.ts');

            case 2:
              _context17.t0 = _context17.sent.default;
              return _context17.abrupt("return", {
                type: 'vanilla',
                Component: _context17.t0
              });

            case 4:
            case "end":
              return _context17.stop();
          }
        }
      }, _callee17);
    }));

    function M001() {
      return _M.apply(this, arguments);
    }

    return M001;
  }(),
  'M002': function () {
    var _M2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee18() {
      return _regeneratorRuntime.wrap(function _callee18$(_context18) {
        while (1) {
          switch (_context18.prev = _context18.next) {
            case 0:
              _context18.next = 2;
              return import('/home/runner/actions-runner/_work/haribo/haribo/frontend/src/components/02-modules/002-Footer/Footer.client.ts');

            case 2:
              _context18.t0 = _context18.sent.default;
              return _context18.abrupt("return", {
                type: 'vanilla',
                Component: _context18.t0
              });

            case 4:
            case "end":
              return _context18.stop();
          }
        }
      }, _callee18);
    }));

    function M002() {
      return _M2.apply(this, arguments);
    }

    return M002;
  }(),
  'M003': function () {
    var _M3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee19() {
      return _regeneratorRuntime.wrap(function _callee19$(_context19) {
        while (1) {
          switch (_context19.prev = _context19.next) {
            case 0:
              _context19.next = 2;
              return import('/home/runner/actions-runner/_work/haribo/haribo/frontend/src/components/02-modules/003-Stage/Stage.client.ts');

            case 2:
              _context19.t0 = _context19.sent.default;
              return _context19.abrupt("return", {
                type: 'vanilla',
                Component: _context19.t0
              });

            case 4:
            case "end":
              return _context19.stop();
          }
        }
      }, _callee19);
    }));

    function M003() {
      return _M3.apply(this, arguments);
    }

    return M003;
  }(),
  'M005': function () {
    var _M4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee20() {
      return _regeneratorRuntime.wrap(function _callee20$(_context20) {
        while (1) {
          switch (_context20.prev = _context20.next) {
            case 0:
              _context20.next = 2;
              return import('/home/runner/actions-runner/_work/haribo/haribo/frontend/src/components/02-modules/005-TeaserListA/TeaserListA.client.ts');

            case 2:
              _context20.t0 = _context20.sent.default;
              return _context20.abrupt("return", {
                type: 'vanilla',
                Component: _context20.t0
              });

            case 4:
            case "end":
              return _context20.stop();
          }
        }
      }, _callee20);
    }));

    function M005() {
      return _M4.apply(this, arguments);
    }

    return M005;
  }(),
  'M016-intro': function () {
    var _M016Intro = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee21() {
      return _regeneratorRuntime.wrap(function _callee21$(_context21) {
        while (1) {
          switch (_context21.prev = _context21.next) {
            case 0:
              _context21.next = 2;
              return import('/home/runner/actions-runner/_work/haribo/haribo/frontend/src/components/02-modules/016-Maps/components/MapsIntro.vue');

            case 2:
              _context21.t0 = _context21.sent.default;
              return _context21.abrupt("return", {
                type: true,
                Component: _context21.t0
              });

            case 4:
            case "end":
              return _context21.stop();
          }
        }
      }, _callee21);
    }));

    function M016Intro() {
      return _M016Intro.apply(this, arguments);
    }

    return M016Intro;
  }(),
  'M016': function () {
    var _M5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee22() {
      return _regeneratorRuntime.wrap(function _callee22$(_context22) {
        while (1) {
          switch (_context22.prev = _context22.next) {
            case 0:
              _context22.next = 2;
              return import('/home/runner/actions-runner/_work/haribo/haribo/frontend/src/components/02-modules/016-Maps/Maps.vue');

            case 2:
              _context22.t0 = _context22.sent.default;
              return _context22.abrupt("return", {
                type: true,
                Component: _context22.t0
              });

            case 4:
            case "end":
              return _context22.stop();
          }
        }
      }, _callee22);
    }));

    function M016() {
      return _M5.apply(this, arguments);
    }

    return M016;
  }(),
  'M018': function () {
    var _M6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee23() {
      return _regeneratorRuntime.wrap(function _callee23$(_context23) {
        while (1) {
          switch (_context23.prev = _context23.next) {
            case 0:
              _context23.next = 2;
              return import('/home/runner/actions-runner/_work/haribo/haribo/frontend/src/components/02-modules/018-InspirationMachine/InspirationMachine.vue');

            case 2:
              _context23.t0 = _context23.sent.default;
              return _context23.abrupt("return", {
                type: true,
                Component: _context23.t0
              });

            case 4:
            case "end":
              return _context23.stop();
          }
        }
      }, _callee23);
    }));

    function M018() {
      return _M6.apply(this, arguments);
    }

    return M018;
  }(),
  'M020': function () {
    var _M7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee24() {
      return _regeneratorRuntime.wrap(function _callee24$(_context24) {
        while (1) {
          switch (_context24.prev = _context24.next) {
            case 0:
              _context24.next = 2;
              return import('/home/runner/actions-runner/_work/haribo/haribo/frontend/src/components/02-modules/020-Newsletter/Newsletter.vue');

            case 2:
              _context24.t0 = _context24.sent.default;
              return _context24.abrupt("return", {
                type: true,
                Component: _context24.t0
              });

            case 4:
            case "end":
              return _context24.stop();
          }
        }
      }, _callee24);
    }));

    function M020() {
      return _M7.apply(this, arguments);
    }

    return M020;
  }(),
  'M021': function () {
    var _M8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee25() {
      return _regeneratorRuntime.wrap(function _callee25$(_context25) {
        while (1) {
          switch (_context25.prev = _context25.next) {
            case 0:
              _context25.next = 2;
              return import('/home/runner/actions-runner/_work/haribo/haribo/frontend/src/components/02-modules/021-Accordion/Accordion.client.ts');

            case 2:
              _context25.t0 = _context25.sent.default;
              return _context25.abrupt("return", {
                type: 'vanilla',
                Component: _context25.t0
              });

            case 4:
            case "end":
              return _context25.stop();
          }
        }
      }, _callee25);
    }));

    function M021() {
      return _M8.apply(this, arguments);
    }

    return M021;
  }(),
  'M022': function () {
    var _M9 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee26() {
      return _regeneratorRuntime.wrap(function _callee26$(_context26) {
        while (1) {
          switch (_context26.prev = _context26.next) {
            case 0:
              _context26.next = 2;
              return import('/home/runner/actions-runner/_work/haribo/haribo/frontend/src/components/02-modules/022-History/History.client.ts');

            case 2:
              _context26.t0 = _context26.sent.default;
              return _context26.abrupt("return", {
                type: 'vanilla',
                Component: _context26.t0
              });

            case 4:
            case "end":
              return _context26.stop();
          }
        }
      }, _callee26);
    }));

    function M022() {
      return _M9.apply(this, arguments);
    }

    return M022;
  }(),
  'M024': function () {
    var _M10 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee27() {
      return _regeneratorRuntime.wrap(function _callee27$(_context27) {
        while (1) {
          switch (_context27.prev = _context27.next) {
            case 0:
              _context27.next = 2;
              return import('/home/runner/actions-runner/_work/haribo/haribo/frontend/src/components/02-modules/024-Search/AsyncSearch.vue');

            case 2:
              _context27.t0 = _context27.sent.default;
              return _context27.abrupt("return", {
                type: true,
                Component: _context27.t0
              });

            case 4:
            case "end":
              return _context27.stop();
          }
        }
      }, _callee27);
    }));

    function M024() {
      return _M10.apply(this, arguments);
    }

    return M024;
  }(),
  'M027': function () {
    var _M11 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee28() {
      return _regeneratorRuntime.wrap(function _callee28$(_context28) {
        while (1) {
          switch (_context28.prev = _context28.next) {
            case 0:
              _context28.next = 2;
              return import('/home/runner/actions-runner/_work/haribo/haribo/frontend/src/components/02-modules/027-TeaserListB/TeaserListB.client.ts');

            case 2:
              _context28.t0 = _context28.sent.default;
              return _context28.abrupt("return", {
                type: 'vanilla',
                Component: _context28.t0
              });

            case 4:
            case "end":
              return _context28.stop();
          }
        }
      }, _callee28);
    }));

    function M027() {
      return _M11.apply(this, arguments);
    }

    return M027;
  }(),
  'M029': function () {
    var _M12 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee29() {
      return _regeneratorRuntime.wrap(function _callee29$(_context29) {
        while (1) {
          switch (_context29.prev = _context29.next) {
            case 0:
              _context29.next = 2;
              return import('/home/runner/actions-runner/_work/haribo/haribo/frontend/src/components/02-modules/029-TeaserListC/TeaserListC.client.ts');

            case 2:
              _context29.t0 = _context29.sent.default;
              return _context29.abrupt("return", {
                type: 'vanilla',
                Component: _context29.t0
              });

            case 4:
            case "end":
              return _context29.stop();
          }
        }
      }, _callee29);
    }));

    function M029() {
      return _M12.apply(this, arguments);
    }

    return M029;
  }(),
  'M030': function () {
    var _M13 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee30() {
      return _regeneratorRuntime.wrap(function _callee30$(_context30) {
        while (1) {
          switch (_context30.prev = _context30.next) {
            case 0:
              _context30.next = 2;
              return import('/home/runner/actions-runner/_work/haribo/haribo/frontend/src/components/02-modules/030-TextList/TextList.client.ts');

            case 2:
              _context30.t0 = _context30.sent.default;
              return _context30.abrupt("return", {
                type: 'vanilla',
                Component: _context30.t0
              });

            case 4:
            case "end":
              return _context30.stop();
          }
        }
      }, _callee30);
    }));

    function M030() {
      return _M13.apply(this, arguments);
    }

    return M030;
  }(),
  'M033': function () {
    var _M14 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee31() {
      return _regeneratorRuntime.wrap(function _callee31$(_context31) {
        while (1) {
          switch (_context31.prev = _context31.next) {
            case 0:
              _context31.next = 2;
              return import('/home/runner/actions-runner/_work/haribo/haribo/frontend/src/components/02-modules/033-Form/Form.vue');

            case 2:
              _context31.t0 = _context31.sent.default;
              return _context31.abrupt("return", {
                type: true,
                Component: _context31.t0
              });

            case 4:
            case "end":
              return _context31.stop();
          }
        }
      }, _callee31);
    }));

    function M033() {
      return _M14.apply(this, arguments);
    }

    return M033;
  }(),
  'M040': function () {
    var _M15 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee32() {
      return _regeneratorRuntime.wrap(function _callee32$(_context32) {
        while (1) {
          switch (_context32.prev = _context32.next) {
            case 0:
              _context32.next = 2;
              return import('/home/runner/actions-runner/_work/haribo/haribo/frontend/src/components/02-modules/040-SubNavigation/SubNavigation.client.ts');

            case 2:
              _context32.t0 = _context32.sent.default;
              return _context32.abrupt("return", {
                type: 'vanilla',
                Component: _context32.t0
              });

            case 4:
            case "end":
              return _context32.stop();
          }
        }
      }, _callee32);
    }));

    function M040() {
      return _M15.apply(this, arguments);
    }

    return M040;
  }(),
  'M044': function () {
    var _M16 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee33() {
      return _regeneratorRuntime.wrap(function _callee33$(_context33) {
        while (1) {
          switch (_context33.prev = _context33.next) {
            case 0:
              _context33.next = 2;
              return import('/home/runner/actions-runner/_work/haribo/haribo/frontend/src/components/02-modules/044-IframeContainer/IframeContainer.client.ts');

            case 2:
              _context33.t0 = _context33.sent.default;
              return _context33.abrupt("return", {
                type: 'vanilla',
                Component: _context33.t0
              });

            case 4:
            case "end":
              return _context33.stop();
          }
        }
      }, _callee33);
    }));

    function M044() {
      return _M16.apply(this, arguments);
    }

    return M044;
  }(),
  'M048': function () {
    var _M17 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee34() {
      return _regeneratorRuntime.wrap(function _callee34$(_context34) {
        while (1) {
          switch (_context34.prev = _context34.next) {
            case 0:
              _context34.next = 2;
              return import('/home/runner/actions-runner/_work/haribo/haribo/frontend/src/components/02-modules/048-StageProduct/StageProduct.client.ts');

            case 2:
              _context34.t0 = _context34.sent.default;
              return _context34.abrupt("return", {
                type: 'vanilla',
                Component: _context34.t0
              });

            case 4:
            case "end":
              return _context34.stop();
          }
        }
      }, _callee34);
    }));

    function M048() {
      return _M17.apply(this, arguments);
    }

    return M048;
  }(),
  'M049': function () {
    var _M18 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee35() {
      return _regeneratorRuntime.wrap(function _callee35$(_context35) {
        while (1) {
          switch (_context35.prev = _context35.next) {
            case 0:
              _context35.next = 2;
              return import('/home/runner/actions-runner/_work/haribo/haribo/frontend/src/components/02-modules/049-AnnouncementLayer/AnnouncementLayer.client.ts');

            case 2:
              _context35.t0 = _context35.sent.default;
              return _context35.abrupt("return", {
                type: 'vanilla',
                Component: _context35.t0
              });

            case 4:
            case "end":
              return _context35.stop();
          }
        }
      }, _callee35);
    }));

    function M049() {
      return _M18.apply(this, arguments);
    }

    return M049;
  }(),
  'M050': function () {
    var _M19 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee36() {
      return _regeneratorRuntime.wrap(function _callee36$(_context36) {
        while (1) {
          switch (_context36.prev = _context36.next) {
            case 0:
              _context36.next = 2;
              return import('/home/runner/actions-runner/_work/haribo/haribo/frontend/src/components/02-modules/050-StageB/StageB.client.ts');

            case 2:
              _context36.t0 = _context36.sent.default;
              return _context36.abrupt("return", {
                type: 'vanilla',
                Component: _context36.t0
              });

            case 4:
            case "end":
              return _context36.stop();
          }
        }
      }, _callee36);
    }));

    function M050() {
      return _M19.apply(this, arguments);
    }

    return M050;
  }(),
  'M052': function () {
    var _M20 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee37() {
      return _regeneratorRuntime.wrap(function _callee37$(_context37) {
        while (1) {
          switch (_context37.prev = _context37.next) {
            case 0:
              _context37.next = 2;
              return import('/home/runner/actions-runner/_work/haribo/haribo/frontend/src/components/02-modules/052-AgeGate/AgeGate.client.ts');

            case 2:
              _context37.t0 = _context37.sent.default;
              return _context37.abrupt("return", {
                type: 'vanilla',
                Component: _context37.t0
              });

            case 4:
            case "end":
              return _context37.stop();
          }
        }
      }, _callee37);
    }));

    function M052() {
      return _M20.apply(this, arguments);
    }

    return M052;
  }(),
  'M053': function () {
    var _M21 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee38() {
      return _regeneratorRuntime.wrap(function _callee38$(_context38) {
        while (1) {
          switch (_context38.prev = _context38.next) {
            case 0:
              _context38.next = 2;
              return import('/home/runner/actions-runner/_work/haribo/haribo/frontend/src/components/02-modules/053-Raffle/Raffle.vue');

            case 2:
              _context38.t0 = _context38.sent.default;
              return _context38.abrupt("return", {
                type: true,
                Component: _context38.t0
              });

            case 4:
            case "end":
              return _context38.stop();
          }
        }
      }, _callee38);
    }));

    function M053() {
      return _M21.apply(this, arguments);
    }

    return M053;
  }(),
  'M054': function () {
    var _M22 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee39() {
      return _regeneratorRuntime.wrap(function _callee39$(_context39) {
        while (1) {
          switch (_context39.prev = _context39.next) {
            case 0:
              _context39.next = 2;
              return import('/home/runner/actions-runner/_work/haribo/haribo/frontend/src/components/02-modules/054-ExternalApp/ExternalApp.vue');

            case 2:
              _context39.t0 = _context39.sent.default;
              return _context39.abrupt("return", {
                type: true,
                Component: _context39.t0
              });

            case 4:
            case "end":
              return _context39.stop();
          }
        }
      }, _callee39);
    }));

    function M054() {
      return _M22.apply(this, arguments);
    }

    return M054;
  }(),
  'M055': function () {
    var _M23 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee40() {
      return _regeneratorRuntime.wrap(function _callee40$(_context40) {
        while (1) {
          switch (_context40.prev = _context40.next) {
            case 0:
              _context40.next = 2;
              return import('/home/runner/actions-runner/_work/haribo/haribo/frontend/src/components/02-modules/055-ReroutingPopup/ReroutingPopup.client.ts');

            case 2:
              _context40.t0 = _context40.sent.default;
              return _context40.abrupt("return", {
                type: 'vanilla',
                Component: _context40.t0
              });

            case 4:
            case "end":
              return _context40.stop();
          }
        }
      }, _callee40);
    }));

    function M055() {
      return _M23.apply(this, arguments);
    }

    return M055;
  }(),
  'M056': function () {
    var _M24 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee41() {
      return _regeneratorRuntime.wrap(function _callee41$(_context41) {
        while (1) {
          switch (_context41.prev = _context41.next) {
            case 0:
              _context41.next = 2;
              return import('/home/runner/actions-runner/_work/haribo/haribo/frontend/src/components/02-modules/056-DamApp/DamApp.vue');

            case 2:
              _context41.t0 = _context41.sent.default;
              return _context41.abrupt("return", {
                type: true,
                Component: _context41.t0
              });

            case 4:
            case "end":
              return _context41.stop();
          }
        }
      }, _callee41);
    }));

    function M056() {
      return _M24.apply(this, arguments);
    }

    return M056;
  }(),
  'M062': function () {
    var _M25 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee42() {
      return _regeneratorRuntime.wrap(function _callee42$(_context42) {
        while (1) {
          switch (_context42.prev = _context42.next) {
            case 0:
              _context42.next = 2;
              return import('/home/runner/actions-runner/_work/haribo/haribo/frontend/src/components/02-modules/062-Wacken/Wacken.vue');

            case 2:
              _context42.t0 = _context42.sent.default;
              return _context42.abrupt("return", {
                type: true,
                Component: _context42.t0
              });

            case 4:
            case "end":
              return _context42.stop();
          }
        }
      }, _callee42);
    }));

    function M062() {
      return _M25.apply(this, arguments);
    }

    return M062;
  }(),
  'M063': function () {
    var _M26 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee43() {
      return _regeneratorRuntime.wrap(function _callee43$(_context43) {
        while (1) {
          switch (_context43.prev = _context43.next) {
            case 0:
              _context43.next = 2;
              return import('/home/runner/actions-runner/_work/haribo/haribo/frontend/src/components/02-modules/063-ModuleLoader/ModuleLoader.vue');

            case 2:
              _context43.t0 = _context43.sent.default;
              return _context43.abrupt("return", {
                type: true,
                Component: _context43.t0
              });

            case 4:
            case "end":
              return _context43.stop();
          }
        }
      }, _callee43);
    }));

    function M063() {
      return _M26.apply(this, arguments);
    }

    return M063;
  }(),
  'M065': function () {
    var _M27 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee44() {
      return _regeneratorRuntime.wrap(function _callee44$(_context44) {
        while (1) {
          switch (_context44.prev = _context44.next) {
            case 0:
              _context44.next = 2;
              return import('/home/runner/actions-runner/_work/haribo/haribo/frontend/src/components/02-modules/065-Quiz/Quiz.vue');

            case 2:
              _context44.t0 = _context44.sent.default;
              return _context44.abrupt("return", {
                type: true,
                Component: _context44.t0
              });

            case 4:
            case "end":
              return _context44.stop();
          }
        }
      }, _callee44);
    }));

    function M065() {
      return _M27.apply(this, arguments);
    }

    return M065;
  }(),
  'M066': function () {
    var _M28 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee45() {
      return _regeneratorRuntime.wrap(function _callee45$(_context45) {
        while (1) {
          switch (_context45.prev = _context45.next) {
            case 0:
              _context45.next = 2;
              return import('/home/runner/actions-runner/_work/haribo/haribo/frontend/src/components/02-modules/066-WheelOfFortune/WheelOfFortune.vue');

            case 2:
              _context45.t0 = _context45.sent.default;
              return _context45.abrupt("return", {
                type: true,
                Component: _context45.t0
              });

            case 4:
            case "end":
              return _context45.stop();
          }
        }
      }, _callee45);
    }));

    function M066() {
      return _M28.apply(this, arguments);
    }

    return M066;
  }(),
  'M067': function () {
    var _M29 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee46() {
      return _regeneratorRuntime.wrap(function _callee46$(_context46) {
        while (1) {
          switch (_context46.prev = _context46.next) {
            case 0:
              _context46.next = 2;
              return import('/home/runner/actions-runner/_work/haribo/haribo/frontend/src/components/02-modules/067-JumpLinks/JumpLinks.client.ts');

            case 2:
              _context46.t0 = _context46.sent.default;
              return _context46.abrupt("return", {
                type: 'vanilla',
                Component: _context46.t0
              });

            case 4:
            case "end":
              return _context46.stop();
          }
        }
      }, _callee46);
    }));

    function M067() {
      return _M29.apply(this, arguments);
    }

    return M067;
  }(),
  'M068': function () {
    var _M30 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee47() {
      return _regeneratorRuntime.wrap(function _callee47$(_context47) {
        while (1) {
          switch (_context47.prev = _context47.next) {
            case 0:
              _context47.next = 2;
              return import('/home/runner/actions-runner/_work/haribo/haribo/frontend/src/components/02-modules/068-ShopList/ShopList.client.ts');

            case 2:
              _context47.t0 = _context47.sent.default;
              return _context47.abrupt("return", {
                type: 'vanilla',
                Component: _context47.t0
              });

            case 4:
            case "end":
              return _context47.stop();
          }
        }
      }, _callee47);
    }));

    function M068() {
      return _M30.apply(this, arguments);
    }

    return M068;
  }(),
  'M069': function () {
    var _M31 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee48() {
      return _regeneratorRuntime.wrap(function _callee48$(_context48) {
        while (1) {
          switch (_context48.prev = _context48.next) {
            case 0:
              _context48.next = 2;
              return import('/home/runner/actions-runner/_work/haribo/haribo/frontend/src/components/02-modules/069-PromotionCalendar/PromotionCalendar.client.ts');

            case 2:
              _context48.t0 = _context48.sent.default;
              return _context48.abrupt("return", {
                type: 'vanilla',
                Component: _context48.t0
              });

            case 4:
            case "end":
              return _context48.stop();
          }
        }
      }, _callee48);
    }));

    function M069() {
      return _M31.apply(this, arguments);
    }

    return M069;
  }(),
  'M070': function () {
    var _M32 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee49() {
      return _regeneratorRuntime.wrap(function _callee49$(_context49) {
        while (1) {
          switch (_context49.prev = _context49.next) {
            case 0:
              _context49.next = 2;
              return import('/home/runner/actions-runner/_work/haribo/haribo/frontend/src/components/02-modules/070-PromotionCalendarForm/PromotionCalendarForm.vue');

            case 2:
              _context49.t0 = _context49.sent.default;
              return _context49.abrupt("return", {
                type: true,
                Component: _context49.t0
              });

            case 4:
            case "end":
              return _context49.stop();
          }
        }
      }, _callee49);
    }));

    function M070() {
      return _M32.apply(this, arguments);
    }

    return M070;
  }()
};/* global components */
/*
 * The "hydration-loader" custom webpack loader will take care of adding components to this file.
 * It will create an async import for every component with a `hydration` property.
 */
window.__hydratedComponentMap = window.__hydratedComponentMap || {};
const hydratedComponentMap = window.__hydratedComponentMap;
let Vue;
let vueInitializationPromise;
let vueCallbackFunction;
let globalData = {};
let uid = 0;

async function initVue() {
	Vue = (await import('vue')).default;

	if (vueCallbackFunction) {
		// Call the defined callback function to give the outside access to the Vue instance, e.g. for adding plugins
		vueCallbackFunction(Vue);
	}
}

async function hydrateElement(element) {
	const componentId = element.getAttribute('data-init');

	// Stop if component does not exist or element was already been hydrated
	if (!components[componentId] || element.hasAttribute('data-initialized')) {
		return;
	}

	// Mark immediately as initialized (in case the init event is triggered again while the async component is still initializing)
	element.setAttribute('data-initialized', 'true');

	// Load component chunk
	const hydrationConfig = await components[componentId]();
	const { Component } = hydrationConfig;

	if (!hydrationConfig) {
		return;
	}

	if (!element.id) {
		element.id = 'hydrated-component-' + ++uid;
	}

	// Init components
	let component;
	if (!(hydrationConfig.type === true || hydrationConfig.type === 'vue')) {
		component = new Component(element);
	} else {
		vueInitializationPromise = await (vueInitializationPromise || initVue());

		let propsData = JSON.parse(element.getAttribute('data-context'));

		// Additionally add global from object rendered in page body
		propsData = { ...globalData, ...propsData };

		// Tell Vue that this is a hydration (Needed for partial hydrations, because Vue SSR renders this attribute only to the outer tag)
		element.setAttribute('data-server-rendered', 'true');

		if (typeof Component === 'object') {
			// Vue object handling
			component = new Vue({
				el: element,
				render: createElement => createElement(Component, {
					props: propsData
				}),
			});
		} else {
			// Vue class handling
			component = new Component({
				el: element,
				propsData,
			});
		}
	}

	hydratedComponentMap[element.id] = component;
}

export async function hydrate() {
	const hydrationElements = document.querySelectorAll('[data-init]');

	if (!hydrationElements.length) {
		// No elements with client side hydration found
		return;
	}

	Array.from(hydrationElements).forEach(async element => hydrateElement(element));
}

export function setGlobalHydrationData(_globalData) {
	globalData = _globalData;
}

export function setVueCallbackFunction(_vueCallbackFunction) {
	vueCallbackFunction = _vueCallbackFunction;
}

export default function initHydration(globalData = null, vueCallbackFunction = null) {
	if (globalData) {
		setGlobalHydrationData(globalData);
	}
	if (vueCallbackFunction) {
		setVueCallbackFunction(vueCallbackFunction);
	}

	hydrate();
	document.addEventListener('DOMContentLoaded', () => hydrate());
}